import { openingDetail } from "./room"

export type reservation = {
    _id: string;
    roomId: string;
    dayCode: string;
    userId: string;
    reservationStart: Date;
    duration: number;
    reservationEnd: Date;
    reservationTimestamp: Date;
    activitySceduledId? : number;
    activityDescription? : string;
}

export const emptyReservation = (): reservation => ({
    _id: '',
    roomId: '',
    dayCode: '',
    userId: '',
    reservationStart: new Date(),
    duration: 0,
    reservationEnd: new Date(),
    reservationTimestamp: new Date(),
})

export type reservationRoom = {
    roomId: string;
    dayCode: string;
    openingDetail: openingDetail;
    reservationSlots: reservationSlot[];
}
export type reservationSlot = {
    startingTime: Date;
    duration: number;
    capacity: number;
    stayingMinutes: number;
    booked: number;
}
export type reservationResponse = {
    result: boolean;
    message: string;
}

// export type openingDetail = {
//     openingTime: time;
//     closingTime: time;
//     duration: number;
// }

export type contactReservationResonse = {
    reservationId: string;
    name: string;
    surname: string;
    email: string;
    tel: string;
    sub: string;
}